module.exports = __webpack_public_path__ + "img/general-electric-mobile_85e1fb460e6fde3455d5d01b1558d18b.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/general-electric-mobile.jpg
// module id = 276
// module chunks = 0